var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 320,
    r: 281,
    fill: "#AA7779"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.875,191.993l50.132,50.132-205.3,205.3L192.573,397.3Z",
    fill: "#F6D6DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M447.743,397.813l-50.194,50.194L191.993,242.451l50.194-50.194Z",
    fill: "#F6D6DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.afbf9a0d32dd0562013352011c36a940.svg";
export { ForwardRef as ReactComponent };